// 한국어 언어 팩
export const ko = {
  // 공통
  common: {
    search: '검색...',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '편집',
    close: '닫기',
    refresh: '새로고침',
    upload: '업로드',
    download: '다운로드',
    loading: '로딩 중...',
    error: '오류',
    success: '성공',
    warning: '경고',
    info: '정보',
    confirm: '확인',
    yes: '예',
    no: '아니오',
  },

  // 헤더
  header: {
    title: 'OnTimeLog 투입시간 관리 시스템',
    search: '검색...',
    theme: {
      light: '라이트 모드',
      dark: '다크 모드',
    },
    notifications: '알림',
    aiAssistant: 'AI',
    user: {
      profile: '사용자 정보',
      settings: '설정',
      logout: '로그아웃',
    },
  },

  // 사이드바 메뉴
  sidebar: {
    brand: 'Onboard AI',
    menu: {
      dashboard: 'Dashboard',
      companyIntel: '기업정보 조회',
      ocr: 'OCR 문서 처리',
      logic: 'Logic Builder',
      dataManagement: 'Data Management',
      dataManagement_files: '파일 관리',
      dataManagement_clean: '데이터 정제',
      dataManagement_db: 'SQL DB',
      risk: 'Risk Analysis',
      action: 'Action Board',
      settings: 'Settings',
      settings_integrations: 'API/RSS 설정',
      settings_apiKeys: 'API Keys',
      settings_general: '일반 설정',
    },
  },

  // 상태바
  statusBar: {
    tasksRunning: '작업 진행 중',
    tasksPending: '대기 중',
    tasksCompleted: '완료',
    systemStatus: '시스템 정상',
    dbConnected: 'DB 연결됨',
    dbDisconnected: '연결 해제',
    aiReady: 'AI 준비',
    version: 'V2.0',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'OnTimeLog 투입시간 관리 시스템에 오신 것을 환영합니다',
    description: '투입시간 관리 시스템',
    kpi: {
      totalTime: 'Total Time',
      activeUsers: 'Active Users',
      newTime: 'New Time',
      timeScore: 'Time Score',
    },    
    recentAlerts: {
      title: '최근 알림',
      newRegulation: '새로운 규정 업데이트',
      riskDetected: '리스크 탐지 완료',
    },
  },

  // Data Management
  dataManagement: {
    title: 'Data Management',
    description: '데이터 업로드, 정제, 데이터베이스 연동을 통합 관리',
    tabs: {
      files: '파일 관리',
      clean: '데이터 정제',
      db: 'SQL DB',
      merge: '데이터 병합',
      review: '파일 리뷰',
    },
    // 파일 관리
    files: {
      dragDrop: '파일을 드래그하거나 클릭하여 업로드',
      supportedFormats: '지원 형식: Excel (.xlsx, .xls), CSV (.csv)',
      selectedFile: '선택된 파일',
      uploading: '업로드 중...',
      uploadSuccess: '파일이 성공적으로 업로드되었습니다',
      uploadError: '파일 업로드에 실패했습니다',
      fileList: '업로드된 파일 목록',
      noFiles: '업로드된 파일이 없습니다',
      fileName: '파일명',
      rows: '행',
      columns: '열',
      size: '크기',
      uploadTime: '업로드 시간',
      actions: '작업',
      preview: '미리보기',
      export: '내보내기',
    },
    // 데이터 정제
    clean: {
      title: '데이터 정제',
      selectFile: '파일 선택',
      selectColumn: '컬럼 선택',
      mode: '정제 모드',
      regex: '정규식 정제',
      replace: '문자열 치환',
      pattern: '패턴',
      replacement: '치환값',
      newColumn: '새 컬럼으로 생성',
      apply: '적용',
      sample: '샘플 데이터',
      before: '변경 전',
      after: '변경 후',
    },
    // SQL DB
    db: {
      title: 'SQL DB 연결',
      connected: '연결됨',
      disconnected: '연결 해제',
      disconnect: '연결 해제',
      serverInfo: '서버 정보',
      server: '서버',
      database: '데이터베이스',
      authMode: '인증 모드',
      windows: 'Windows 인증',
      sql: 'SQL Server 인증',
      username: '사용자명',
      password: '비밀번호',
      connect: '연결',
      connecting: '연결 중...',
      testConnection: '연결 테스트',
      connectionSuccess: '데이터베이스 연결 성공',
      connectionError: '데이터베이스 연결 실패',
      selectDatabase: '데이터베이스 선택',
      selectTable: '테이블 선택',
      query: '쿼리',
      execute: '실행',
      executing: '실행 중...',
      results: '결과',
      uploadToDb: 'DB에 업로드',
      tableName: '테이블명',
      exportToExcel: 'Excel로 내보내기',
    },
  },

  // Settings
  settings: {
    title: 'Settings',
    description: 'LLM API Key 설정 및 시스템 구성',
    tabs: {
      apiKeys: 'API Keys',
      general: '일반 설정',
    },
    // API Keys
    apiKeys: {
      title: 'LLM Provider API Keys',
      description: 'AI 기능을 사용하기 위해 API Key를 설정하세요',
      providers: {
        openai: 'OpenAI',
        gemini: 'Google Gemini',
        perplexity: 'Perplexity AI',
        huggingface: 'HuggingFace',
      },
      apiKey: 'API Key',
      model: '모델',
      enabled: '활성화',
      default: '기본값으로 설정',
      show: '표시',
      hide: '숨기기',
      save: '저장',
      saved: 'API Key가 저장되었습니다',
      security: {
        title: '보안 안내',
        storage: 'API Key는 로컬 스토리지에 암호화되어 저장됩니다',
        production: '실제 연동 시 백엔드 환경 변수 사용을 권장합니다',
        billing: 'API 사용 시 해당 제공업체에서 요금이 부과될 수 있습니다',
        testing: '현재는 테스트 환경이며 실제 API 호출은 이루어지지 않습니다',
      },
    },
    // 일반 설정
    general: {
      title: '일반 설정',
      language: {
        title: '언어 설정',
        description: '시스템 표시 언어를 선택하세요',
        label: '언어',
        korean: '한국어',
        english: 'English',
        change: '언어 변경',
        changed: '언어가 변경되었습니다',
      },
      theme: {
        title: '테마 설정',
        description: '다크 모드 또는 라이트 모드를 선택하세요',
        dark: '다크 모드',
        light: '라이트 모드',
      },
      notifications: {
        title: '알림 설정',
        description: '시스템 알림 설정을 관리하세요',
        enable: '알림 활성화',
        sound: '알림음',
        desktop: '데스크톱 알림',
      },
    },
  },

  // AI Assistant
  aiAssistant: {
    title: 'AI Assistant',
    placeholder: 'AI에게 질문하세요...',
    send: '전송',
    selectLLM: 'LLM 선택',
    currentPage: '현재 페이지',
    context: '컨텍스트',
  },

  // 작업 (Tasks)
  tasks: {
    title: '백그라운드 작업',
    status: {
      pending: '대기 중',
      running: '진행 중',
      completed: '완료',
      failed: '실패',
      cancelled: '취소됨',
    },
    actions: {
      cancel: '취소',
      delete: '삭제',
      retry: '재시도',
      viewDetails: '상세 보기',
    },
    fileReview: '파일 리뷰',
    fileMerge: '파일 병합',
    dataCleaning: '데이터 정제',
    noTasks: '진행 중인 작업이 없습니다',
  },

  // 배지
  badges: {
    new: '새로운',
    completed: '완료',
    inProgress: '진행 중',
    connected: '연결됨',
  },

  // 에러 메시지
  errors: {
    fileUpload: '파일 업로드 실패',
    fileFormat: '지원하지 않는 파일 형식입니다',
    networkError: '네트워크 오류가 발생했습니다',
    dbConnection: '데이터베이스 연결 실패',
    unauthorized: '권한이 없습니다',
    notFound: '찾을 수 없습니다',
    serverError: '서버 오류가 발생했습니다',
  },

  // 성공 메시지
  success: {
    fileUpload: '파일이 성공적으로 업로드되었습니다',
    fileSaved: '파일이 저장되었습니다',
    dataClean: '데이터 정제가 완료되었습니다',
    dbConnected: '데이터베이스에 연결되었습니다',
    settingsSaved: '설정이 저장되었습니다',
  },
};

export default ko;

